import { render, staticRenderFns } from "./ChooseGroup.vue?vue&type=template&id=5acb7b80&"
import script from "./ChooseGroup.vue?vue&type=script&lang=ts&"
export * from "./ChooseGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports